import { getFeature } from '@aytm/app/stats/lib/stat-page'
// Vector constants and data converted from data_centrifuge/vectors.coffee (DC-v3 taxonomy).

export const VECTORS_RAW = [
  'Twinned_Responses',
  'Inconsistency_Responses',
  'Random_Responses',
  'Pacing_Anomalies',
  'Response_Patterns',
  'Interrupted_Sessions',
  'HB_Model_Fit_Issues',
  'Attention_Checks',
  'Verbatim_Anomalies',
  'Digital_Body_Language_Signals'
]

export const VECTORS_RAW_COLORS = [
  '#800202',
  '#bf0000',
  '#9a559e',
  '#723f98',
  '#235496',
  '#2074a0',
  '#12a4c0',
  '#11a69c',
  '#7eb852',
  '#a2ca04'
]

export const VECTORS_GROUPS = [
  {
    id: 'Twinned_Responses',
    vectors: ['Twinned_Response', 'Twinned_Open_Ends', 'Image_Response_Duplicate', 'Twinned_Tempo'],
    names: ['Twinned Closed', 'Twinned Open', 'Twinned Image', 'Twinned Tempo']
  },
  {
    id: 'Inconsistency_Responses',
    vectors: ['Inconsistency_Response'],
    names: ['Inconsistent Response']
  },
  {
    id: 'Random_Responses',
    vectors: ['Random_Response'],
    names: ['Random Response']
  },
  {
    id: 'Pacing_Anomalies',
    vectors: ['Relative_Speeding', 'Impossible_Speeding', 'Laggards'],
    names: ['Relative Speeding', 'Impossible Speeding', 'Laggards']
  },
  {
    id: 'Response_Patterns',
    vectors: ['Response_Pattern'],
    names: ['Response Pattern']
  },
  {
    id: 'Interrupted_Sessions',
    vectors: ['Interrupted_Session'],
    names: ['Interrupted Session']
  },
  {
    id: 'HB_Model_Fit_Issues',
    vectors: ['Low_HB_Model_Fit'],
    names: ['Low HB Model Fit']
  },
  {
    id: 'Attention_Checks',
    vectors: ['Attention_Check'],
    names: ['Attention Check']
  },
  {
    id: 'Verbatim_Anomalies',
    vectors: [
      'Gibberish_Verbatim',
      'Random_Verbatim',
      'Repeated_Verbatim',
      'Offensive_Verbatim',
      'LLM_Honeypot',
      'Terse_Verbatim',
      'Verbose_Verbatim',
      'LLM_Detection'
    ],
    names: ['Gibberish', 'Random', 'Repeats', 'Offensive', 'LLM Honeypot', 'Terse', 'Verbose', 'LLM Detection']
  },
  {
    id: 'Digital_Body_Language_Signals',
    vectors: ['Paste_Detection', 'Body_Language'],
    names: ['Copy-Paste Detection', 'Bot Detection']
  }
]

export const VECTORS_NAMES = {
  Twinned_Responses: 'Twinned Responses',
  Inconsistency_Responses: 'Inconsistent Responses',
  Random_Responses: 'Random Responses',
  Pacing_Anomalies: 'Pacing Anomalies',
  Response_Patterns: 'Response Patterns',
  Interrupted_Sessions: 'Interrupted Sessions',
  HB_Model_Fit_Issues: 'HB Model Fit Issues',
  Attention_Checks: 'Attention Checks',
  Verbatim_Anomalies: 'Verbatim Anomalies',
  Digital_Body_Language_Signals: 'Digital Body Language Signals'
}

export const VECTORS_ICONS = {
  Twinned_Responses:
    'M80.77,31.45a.42.42,0,0,1,0-.12c-1.14-3.22.54-3,.21-4.16-.88-3.15-5.65-4-6.48-4.13a21,21,0,0,0-19.3-4.32C26,27,81.09,58.26,61.51,73.94c-3.76,3-8.42,6.31-8.75,7.57s4.57.36,8-.63c.47,3,1.37,7.6,2.22,7.47,2-.31,2.64-10.13,6.39-14C79.24,64.13,87.76,46.42,80.77,31.45ZM60.24,28.2a2.59,2.59,0,1,1-1.91-3.1A2.57,2.57,0,0,1,60.24,28.2ZM37.92,20.53c3.76-3,8.42-6.31,8.75-7.57s-4.58-.36-8,.63c-.47-3-1.38-7.6-2.22-7.47-2,.31-2.64,10.13-6.39,14C20.19,30.34,11.67,48.05,18.66,63c0,0,0,.07,0,.12,1.14,3.22-.54,3-.21,4.16.88,3.15,5.65,4,6.48,4.13a21,21,0,0,0,19.3,4.32C73.46,67.43,18.34,36.21,37.92,20.53Zm6.3,47a2.59,2.59,0,1,1-1.92-3.11A2.57,2.57,0,0,1,44.22,67.49Z',
  Inconsistency_Responses:
    'M85.18,24.7a1.8,1.8,0,0,0-1.8,1.79v2a1.78,1.78,0,0,1-1.78,1.78H79.54a1.79,1.79,0,0,1-1.79-1.78v-2a1.8,1.8,0,0,0-3.59,0v2a5.36,5.36,0,0,0,4,5.17c0,2.1-2.44,2.27-3.18,2.27H63.81a1.2,1.2,0,0,1-1.18-1.18,2.4,2.4,0,1,0-4.79,0,6,6,0,0,0,6,6h4.26a3.33,3.33,0,0,1-.51,2.46,3.76,3.76,0,0,1-3.07,1.67h-1a2.4,2.4,0,0,0-2.4,2.39v0h0V50a75.15,75.15,0,0,0-8.61-2.47V39.34a3,3,0,0,0-3-3c-9.24,0-9.24-4.32-9.24-6a1.11,1.11,0,0,0,0-.19h15a8.39,8.39,0,0,0,8.38-8.38v-3a3,3,0,0,0-6,0v3a2.4,2.4,0,0,1-2.39,2.4h-3.1a2.4,2.4,0,0,1-2.4-2.4v-3a3,3,0,0,0-6,0v3a8.3,8.3,0,0,0,.36,2.4H31c-1.07,0-4.58-.25-4.6-3.39a8.71,8.71,0,0,0,7.35-8.59V10.92a3,3,0,1,0-6,0v1.33A2.71,2.71,0,0,1,25,15H21.73A2.72,2.72,0,0,1,19,12.25V10.92a3,3,0,1,0-6,0v1.33a8.7,8.7,0,0,0,7.35,8.59c0,6.44,5.49,9.37,10.58,9.37h3.33c0,.06,0,.12,0,.19,0,3.31,1.27,10.66,12.23,11.79v4.15c-5.87-1-10.81-1.24-11.85-.56s.66,2-1,2.94c0,0-.05.1-.09.13C19.65,58.1,18.51,75.69,31,87.71c1.07,1,3.78,7.93,8.54,8.66.69.1,0-2.39-.19-6.17-.48-.15,11.19-1,9.25-2.21-6.2-3.95-10.19-1.67-12.32-4.26-14.87-18,37-5.85,33.78-27.39-.23-1.52-1.8-3-4.15-4.24V49.52a8.48,8.48,0,0,0,5.65-3.66,8,8,0,0,0,1.34-5.12H75c3.83,0,7.94-2.21,8-7.05a5.37,5.37,0,0,0,4-5.18v-2A1.79,1.79,0,0,0,85.18,24.7ZM59.45,58.94a2.68,2.68,0,0,1-5-2A2.64,2.64,0,0,1,58,55.5,2.57,2.57,0,0,1,59.45,58.94Z',
  Random_Responses:
    'M77.46,38.18,57.74,48.77a8.7,8.7,0,0,0-4.14,6.94V80c0,2.59,1.83,3.64,4.08,2.36L77.53,70.86a9,9,0,0,0,4.08-7V40.67C81.61,38.08,79.74,37,77.46,38.18ZM62.8,75c-2.28,1.23-4.36.29-4.65-2.1a7.18,7.18,0,0,1,3.6-6.58c2.27-1.23,4.37-.29,4.66,2.1A7.18,7.18,0,0,1,62.8,75Zm6-10.72c-2.28,1.23-4.36.29-4.65-2.1a7.19,7.19,0,0,1,3.6-6.58c2.28-1.23,4.37-.3,4.65,2.1A7.16,7.16,0,0,1,68.81,64.3ZM75,53.44c-2.28,1.24-4.37.3-4.66-2.1a7.19,7.19,0,0,1,3.61-6.57c2.27-1.24,4.37-.3,4.65,2.09A7.18,7.18,0,0,1,75,53.44ZM42.72,49.16,22.48,38.47c-2.29-1.21-4.16-.08-4.16,2.51V64.23a9.06,9.06,0,0,0,4.08,7.06L42.81,83.07c2.24,1.29,4.08.24,4.08-2.35V56.06A8.62,8.62,0,0,0,42.72,49.16ZM28.51,59.69a7.93,7.93,0,0,1-4.21-7.13c.24-2.66,2.5-3.76,5.07-2.49a7.92,7.92,0,0,1,4.2,7.13C33.33,59.86,31.07,61,28.51,59.69Zm7.33,12.76a7.91,7.91,0,0,1-4.2-7.13c.23-2.65,2.5-3.76,5.07-2.49A7.94,7.94,0,0,1,40.91,70C40.67,72.62,38.41,73.74,35.84,72.45ZM74.49,29,54.25,17.35a9,9,0,0,0-8.16,0L26,29c-2.25,1.28-2.21,3.33.08,4.54L46.23,44.18a10.44,10.44,0,0,0,8.55,0L74.42,33.61C76.7,32.39,76.73,30.33,74.49,29ZM54.62,32.94a8.76,8.76,0,0,1-9.06-1c-2.18-2-1.67-4.69,1.15-6.1a8.73,8.73,0,0,1,9.07,1C58,28.79,57.44,31.52,54.62,32.94Z',
  Pacing_Anomalies:
    'M14.56,50.16A3.55,3.55,0,1,1,11,46.61,3.56,3.56,0,0,1,14.56,50.16ZM81.9,29.89A32,32,0,1,1,25.44,53.71h-5a3.55,3.55,0,1,1,0-7.1h6.3a2.74,2.74,0,0,0,0-5.48H8.65a3.55,3.55,0,0,1,0-7.1H32.23a1,1,0,0,0,0-2l-6.09,0a3.55,3.55,0,0,1,0-7.1H37.51a31.94,31.94,0,0,1,40,.49L79,24.05l-4.47-4.47L78.1,16a34.76,34.76,0,0,1,7.65,5.77,33.61,33.61,0,0,1,5.68,7.56l-3.61,3.62-4.47-4.48ZM79.28,50.11a22,22,0,1,0-22,22A22,22,0,0,0,79.28,50.11ZM65.44,35l.48-.48a16,16,0,0,0-23.87,6.18l1.4.65c3.67-5.61,13.22-5.53,17.21-1.53ZM55.12,48.85a1.81,1.81,0,0,0,.13,2.56L57.05,53a3.29,3.29,0,0,0,1.3.48,1.79,1.79,0,0,0,1.25-.6L71.33,37.17l-1.8-1.64Z',
  Response_Patterns:
    'M10.6,74.34A2.82,2.82,0,0,1,9.2,74,2.9,2.9,0,0,1,8.06,70L34.43,22.45A2.9,2.9,0,0,1,39.87,24L38.14,59,58.47,22.32a2.9,2.9,0,0,1,5.43,1.32L65,60.53,86.29,22.17A2.9,2.9,0,1,1,91.36,25L65,72.57a2.9,2.9,0,0,1-5.44-1.32l-1.13-36.9L37.17,72.71a2.9,2.9,0,0,1-5.43-1.54l1.72-35L13.14,72.84A2.9,2.9,0,0,1,10.6,74.34Z',
  Interrupted_Sessions:
    'M44.13,67.54a69.63,69.63,0,0,1-.41,8.29q-.45,5-.93,10c0,.34.05,1.39-.18,1.64s-.59.1-.94,0c-.8-.15-1.61-.33-2.41-.53A43.63,43.63,0,0,1,26,81.18,43.55,43.55,0,0,1,6.6,49.29c0-.52,8.73-.91,9.44-.92,3.7,0,7.41.07,11.12.18,1.66.05,3.33,0,5,0a41.56,41.56,0,0,1,5,0,33.64,33.64,0,0,1,4,.47,13.44,13.44,0,0,1,2.13.66c.26.11,1.72.6,1.77.88a5.41,5.41,0,0,1-.28,3c-.22.52-.51,1-.72,1.54a8.17,8.17,0,0,0-.44,2.78A39.88,39.88,0,0,0,43.75,62C43.89,63.88,44.08,65.71,44.13,67.54ZM58.89,83.6c-.29.16-.5.29-.56.33-1.62,1.15-1.16,1.91-.67,3.73A43.6,43.6,0,0,0,93.32,49.23a31.17,31.17,0,0,0-5.84-.56,36.78,36.78,0,0,0-6.39,1c-1,.18-2.07.36-3.08.63a6.58,6.58,0,0,0-2.62,1.19A3,3,0,0,0,74.21,54c.07.59.34,1.25,0,1.72a1.47,1.47,0,0,1-.7.44,23.21,23.21,0,0,1-7.17,1.53,8,8,0,0,0-.66,4.62l.87,15.48a1.73,1.73,0,0,1-.06.75c-.21.56-.89.76-1.48.87a5.53,5.53,0,0,0-2.12.7A1.81,1.81,0,0,0,62,82,17.26,17.26,0,0,0,58.89,83.6ZM55,75.85l-.74.56c-.75.58-.1.64-.2,1.19a15.8,15.8,0,0,0-.48,1.7,1.63,1.63,0,0,0,.09.76c.1.24.3.43.43.67.24.45.22,1.06.62,1.38,1.31,1.06,2.28-1.29,3.45-1.23.43,0,.91.2,1.25-.06a1.61,1.61,0,0,0,.32-.44A2.84,2.84,0,0,1,61.86,79a6,6,0,0,0-1.65-2.44,26.81,26.81,0,0,0-3.32-2.19ZM50.48,87.16a.14.14,0,0,0,0,.14.09.09,0,0,0,.07,0,6.58,6.58,0,0,0,2.07.27.31.31,0,0,0,.21,0c.12-.09.22-.35.32-.48a5.9,5.9,0,0,0,.57-.55A2.5,2.5,0,0,0,54.21,85a.46.46,0,0,0-.05-.23.44.44,0,0,0-.13-.14,2.43,2.43,0,0,0-2.11-.48C51.07,84.55,50.67,86.35,50.48,87.16ZM74.81,26.64a29.1,29.1,0,0,0-54.16,14.8h7.67A21.43,21.43,0,0,1,68.11,30.37L63.46,33,78.89,42.2l.3-18Z',
  HB_Model_Fit_Issues:
    'M28.11,70.8a3,3,0,0,1-2.7-4.29l8.87-18.46a35.21,35.21,0,0,1-12.52,7,25.88,25.88,0,0,1-7.39,1.09,21.48,21.48,0,0,1-10.45-2.5A3,3,0,0,1,7,48.49c.27.16,5.5,3.11,13.24.75,7.16-2.18,18-9.53,28.89-32.13a3,3,0,1,1,5.39,2.6c-.36.74-.72,1.45-1.09,2.17a2.19,2.19,0,0,1-.17.49L30.81,69.11A3,3,0,0,1,28.11,70.8ZM96,48.4c-.31-.18-7.51-4.46-17.84-1.41a35.19,35.19,0,0,0-12.76,7.17l12-25.06a3,3,0,1,0-5.39-2.6L45.19,82.42a3,3,0,0,0,4.29,3.82,2.89,2.89,0,0,0,1.3-1.33C61.69,62.31,72.52,55,79.68,52.78c7.74-2.35,13,.6,13.23.75A3,3,0,0,0,96,48.4ZM51.44,55.8,34.72,90.6a3.59,3.59,0,0,1-6.48-3.11L45,52.69a6.76,6.76,0,0,1,5-10.34L65.77,9.4a3.59,3.59,0,0,1,6.48,3.11l-15.84,33a6.75,6.75,0,0,1-5,10.33Zm-.75-3.54a3.18,3.18,0,1,0-3.18-3.18A3.19,3.19,0,0,0,50.69,52.26Z',
  Attention_Checks:
    'M12.2,16.4c-1.3-1.3-3.4-1.3-4.7,0-1.3,1.3-1.3,3.4,0,4.7l8.8,8.8h-5.3c-1.9,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3h13.4c1.9,0,3.3-1.5,3.3-3.3v-13.4c0-1.9-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3v5.3s-8.8-8.8-8.8-8.8ZM50,63.4c-9,0-15.9-7.3-19.3-13.4,3.4-6.1,10.3-13.4,19.3-13.4s15.9,7.3,19.3,13.4c-3.4,6.1-10.3,13.4-19.3,13.4ZM50,29.9c-13.6,0-22.5,11.4-26,18.4-.5,1.1-.5,2.3,0,3.4,3.5,7,12.4,18.4,26,18.4s22.5-11.4,26-18.4c.5-1.1.5-2.3,0-3.4-3.5-7-12.4-18.4-26-18.4ZM92.5,16.4c-1.3-1.3-3.4-1.3-4.7,0l-8.8,8.8v-5.3c0-1.9-1.5-3.3-3.4-3.3s-3.3,1.5-3.3,3.3v13.4c0,1.8,1.5,3.3,3.3,3.3h13.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3h-5.3l8.8-8.8c1.3-1.3,1.3-3.4,0-4.7h0ZM12.2,83.6l8.8-8.8v5.3c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3v-13.4c0-1.8-1.5-3.3-3.3-3.3h-13.4c-1.9,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3h5.3l-8.8,8.8c-1.3,1.3-1.3,3.4,0,4.7,1.3,1.3,3.4,1.3,4.7,0h0ZM92.5,83.6c1.3-1.3,1.3-3.4,0-4.7l-8.8-8.8h5.3c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3h-13.4c-1.8,0-3.3,1.5-3.3,3.3v13.4c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3v-5.3l8.8,8.8c1.3,1.3,3.4,1.3,4.7,0h0ZM50,58.9c4.9,0,8.9-4,8.9-8.9s-4-8.9-8.9-8.9-8.9,4-8.9,8.9,4,8.9,8.9,8.9Z',
  Verbatim_Anomalies:
    'M90.3,46.4c0-6.1-5.7-7.7-11.9-7.7-4.7,0-11.8,1.4-11.8,7.3s6.7,7.2,12.2,7.1c-.2,1.5-2.3,4.1-3.2,4.6,0,0-.1.1-.2.2-3.2-2.9-8.7-3.8-14.4-3.8-1.9,0-4.2.2-6.4.6,4.1-4.2,6.4-9,6.4-13.5,0-12.8-11.9-16-24.9-16-9.8,0-24.7,2.9-24.7,15.3s13.9,15.1,25.5,14.9c-.4,3.1-4.9,8.5-6.7,9.7-.4.3-.6.8-.5,1.3.1.5.6.8,1.1.8,4.8-1,9.3-2.7,13.1-4.7-.2.7-.3,1.5-.3,2.4,0,9.5,9.8,10.6,17.8,10.4-.3,2.2-3.4,5.9-4.7,6.8-.3.2-.4.6-.3.9s.4.6.8.6c12.4-2.7,21.1-10.8,21.1-18.1,0-2.8-.8-5-2.3-6.6,8.3-1.9,14.2-7.4,14.2-12.3h0ZM75,48.1c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9ZM27.1,44.9c-2.2,0-4.1-1.8-4.1-4.1s1.8-4,4.1-4,4.1,1.8,4.1,4-1.8,4.1-4.1,4.1ZM41.2,40.8c0-2.2,1.8-4,4.1-4s4.1,1.8,4.1,4-1.8,4.1-4.1,4.1-4.1-1.8-4.1-4.1ZM56.1,67.9c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8,2.8,1.3,2.8,2.8-1.3,2.8-2.8,2.8ZM67,67.9c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8,2.8,1.3,2.8,2.8-1.3,2.8-2.8,2.8ZM82.5,48.1c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
  Digital_Body_Language_Signals:
    'M79,62.3c-.3,1.1-1.4,1.8-2.5,1.8h-16.7l9.7,19.4c.9,1.7.2,3.8-1.6,4.7s-3.8.2-4.7-1.6l-9.7-19.4-10,13.3c-.7.9-1.9,1.3-2.9.9-1.1-.3-1.8-1.4-1.8-2.5v-43.7c0-1,.6-1.9,1.5-2.4.9-.4,2-.3,2.7.3l35,26.2c.9.7,1.3,1.9.9,2.9ZM42.6,24c1.8,0,3.3-1.5,3.3-3.3v-4.4c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3v4.4c0,1.8,1.5,3.3,3.3,3.3ZM27.2,33.1h-4.4c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3h4.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3ZM30.6,20.1c-1.3-1.3-3.4-1.3-4.6,0-1.3,1.3-1.3,3.4,0,4.6l3.1,3.1c1.3,1.3,3.3,1.3,4.6,0s1.3-3.3,0-4.6l-3.1-3.1ZM55.9,27.8l3.1-3.1c1.3-1.3,1.3-3.3,0-4.6-1.3-1.3-3.4-1.3-4.6,0l-3.1,3.1c-1.3,1.3-1.3,3.4,0,4.6s3.3,1.3,4.6,0Z'
}

export const SUSPICION_LEVELS = [
  ['High', 4],
  ['Moderate and up', 3],
  ['Low and up', 2],
  ['Minor and up', 1]
]

// The Advisory tier sits outside SUSPICION_LEVELS on purpose: it is visible everywhere the
// scored tiers are, but it is not a rung on the threshold, so it carries a label and no level.
export const ADVISORY_LABEL = 'Advisory'

export const DEFAULT_FILTER = 'all'
// "Not quarantined": the flagged responses still awaiting a decision.
export const OUTSTANDING_FILTER = 'flagged'
export const DEFAULT_SUSPICION_LEVEL = 1

// Fallback: direct icon, then parent group icon, then null.
export const getVectorIcon = id => {
  if (VECTORS_ICONS[id]) return VECTORS_ICONS[id]
  const parent = getParentGroup(id)
  return (parent && VECTORS_ICONS[parent]) || null
}

// Get vector color from raw array (with modulo wrap for safety).
export const getVectorColor = vectorId => {
  const index = VECTORS_RAW.indexOf(vectorId)
  return index >= 0 ? VECTORS_RAW_COLORS[index % VECTORS_RAW_COLORS.length] : '#aeaeae'
}

// BETA / not-yet-released vectors are hidden from every surface — checklist, chart slots, summary.
// Leaf ids are filtered in seedEmptyGroups / calcGroups; parent ids in getVisibleRaw.
export const getExcludedVectors = () => getFeature('stat_data_cleaning_run_exclude_vectors')?.value || []

// Visible raw list = raw minus admin-excluded vectors. Use this whenever counting
// vectors for display ("N responses from V vectors") so excluded vectors don't inflate the count.
export const getVisibleRaw = () => {
  const excluded = getExcludedVectors()
  return VECTORS_RAW.filter(id => !excluded.includes(id))
}

// Same value carries two roles with different semantics (see spec §4.3):
// - getSuspicionExcludedVectors: hard-excludes the parent id from aggregate score derivation.
// - getDefaultDisabledVectors: seeds @disabledVectors at first load so listed ids ship unchecked.
const SUSPICION_EXCLUDE_FALLBACK = ['Interrupted_Session', 'Terse_Verbatim', 'Verbose_Verbatim', 'Inconsistency_Response']

export const getSuspicionExcludedVectors = () =>
  getFeature('stat_data_cleaning_run_suspicion_exclude')?.value || SUSPICION_EXCLUDE_FALLBACK

export const getDefaultDisabledVectors = () =>
  getFeature('stat_data_cleaning_run_suspicion_exclude')?.value || SUSPICION_EXCLUDE_FALLBACK

// Lazy O(1) child→parent lookup; @groups is static so the cache stays valid for the page lifetime.
let parentGroupByChild = null
export const getParentGroup = childId => {
  if (!parentGroupByChild) {
    parentGroupByChild = {}
    VECTORS_GROUPS.forEach(g => {
      g.vectors.forEach(c => {
        parentGroupByChild[c] = g
      })
    })
  }
  return parentGroupByChild[childId]?.id || null
}

// Display name -> its primary's display name. The run's flagged list is meant to name primaries,
// but a sub-vector name reaches it too, and every consumer of that list reasons in primary names.
// A name that is already a primary's, or one the taxonomy does not carry at all, passes through.
let primaryNameByName = null
export const toPrimaryVectorName = name => {
  if (!primaryNameByName) {
    primaryNameByName = {}
    VECTORS_GROUPS.forEach(g => {
      g.names.forEach(childName => {
        primaryNameByName[childName] = VECTORS_NAMES[g.id]
      })
    })
  }
  return primaryNameByName[name] || name
}

// The vector id a per-vector re-run must send. RUN AGAIN emits includeVectors, which AYTMstats
// getEnabledGroups and the Rserve intersect both match against LEAF ids. A single-leaf group
// renders as a flat parent row carrying the group id, which matches no leaf downstream and
// silently no-ops — collapse it to its child leaf. Leaf rows and multi-leaf group ids pass through.
export const runAgainVectorId = id => {
  const group = VECTORS_GROUPS.find(g => g.id === id)
  return group?.vectors.length === 1 ? group.vectors[0] : id
}
